module.exports = {"341324100":"泗城镇","341324101":"墩集镇","341324102":"丁湖镇","341324103":"草沟镇","341324104":"长沟镇","341324105":"黄圩镇","341324106":"大庄镇","341324107":"山头镇","341324108":"刘圩镇","341324109":"黑塔镇","341324110":"草庙镇","341324111":"屏山镇","341324112":"大路口镇","341324113":"大杨镇","341324114":"瓦坊镇","341324400":"泗县开发区管委会（泗县当涂现代产业园）"}


//////////////////
// WEBPACK FOOTER
// ./src/town/341324.json
// module id = 1241
// module chunks = 0